var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/Reset.26b7917c.png","uri@2x": __webpack_public_path__ + "static/media/Reset.31eedfdc.png","uri@3x": __webpack_public_path__ + "static/media/Reset.40601ccf.png",
    width: 16,
    height: 20
});